import { createApp, type Plugin } from 'vue';

import App from './App.vue';

import './style.css';
import 'splitpanes/dist/splitpanes.css';
import '@next-market-map-api/marketmap/style.css';

import { worker } from '@libs/mock';

const app = createApp(App);

// Disable MSW outside dev to avoid mocking real APIs in staging/production.
// Prefer VITE_ENABLE_MSW + dynamic import for explicit environment control.
if (
  import.meta.env.MODE !== 'production' &&
  import.meta.env.MODE !== 'staging' &&
  import.meta.env.MODE !== 'preproduction'
) {
  worker.start({ onUnhandledRequest: 'bypass' });
}

// Install all plugins inside the `plugins` folder
Object.values<Plugin>(import.meta.glob('./plugins/*.ts', { eager: true })).map(
  (plugin) => plugin.install?.(app)
);

app.mount('#app');
